<template>
  <div ref="gate" class="flex w-full self-center" :class="{'h-full' : !height}" :style="{height: `${height}px`}">
    <img v-if="showPole && showExtraLeft" :src="pole" alt="outer-right-pole">
    <img v-if="showExtraLeft" :src="extraLeft">
    <img :src="pole" alt="left-pole" :class="{'opacity-0': !showPole}">
    <img :src="gateLeft" alt="left-gate">
    <img :src="gateRight" alt="right-gate">
    <img :src="pole" alt="right-pole" :class="{'opacity-0': !showPole}">
    <img v-if="showExtraRight" :src="extraRight">
    <img v-if="showPole && showExtraRight" :src="pole" alt="outer-right-pole">
  </div>
</template>

<script>
export default {
  props: {
    gate: {
      type: Object,
      required: true,
    },
    // form configuration
    config: {
      type: Object,
      required: true,
    },
    showPole: {
      type: Boolean,
      default: true,
    },
    showExtraLeft: {
      type: Boolean,
      default: false,
    },
    showExtraRight: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    height: false,
  }),
  computed: {
    pole() {
      return require(`~/assets/img/palen/${this.gate?.height}.svg`);
    },
    gateLeft() {
      return require(`~/assets/img/poorten/${this.gate?.slug}/basis/links.svg`);
    },
    gateRight() {
      return require(`~/assets/img/poorten/${this.gate?.slug}/basis/rechts.svg`);
    },
    extraLeft() {
      return require(`~/assets/img/poorten/${this.gate?.slug}/looppoort/links.svg`);
    },
    extraRight() {
      return require(`~/assets/img/poorten/${this.gate?.slug}/looppoort/rechts.svg`);
    },
    aspectRatio() {
      if (this.showExtraRight && this.showExtraLeft) {
        return 0.40;
      } else if (this.showExtraRight || this.showExtraLeft) {
        return 0.50;
      } else {
        return 0.70;
      }
    },
  },
  watch: {
    showExtraLeft() {
      this.setHeight();
    },
    showExtraRight() {
      this.setHeight();
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.setHeight);
  },
  mounted() {
    window.addEventListener('resize', this.setHeight);
    this.setHeight();
  },
  methods: {
    setHeight() {
      this.height = this.$refs.gate.clientWidth * this.aspectRatio;
    },
  },
};
</script>
